<section class="main-content">
    <div class="content-form-firma">
        <h1 class="titulo-principal text-center text-color-primary">{{titulo | translate}}</h1>
        <p class="text-justify">{{textoDescripcion | translate}}</p>

        <!-- upload dni  -->
        <div class="content-upload" [hidden]="!mostrarUploadDni">
            <label>
                {{'contratar.datos-personales.foto-identificacion' | translate}}
                <span [hidden]="!dniObligatorio">*</span>
            </label>
            <div class="upload-dni">
                <div>
                    <div class="upload-container upload-frente">
                        <input type="file" (change)="onFileChange($event)" #imageInput accept="image/*" />
                    </div>
                    <div class="detalle-archivo">
                        <p class="nombre-archivo">{{ nombreArchivoDni }}</p>
                    </div>

                </div>

                <div>
                    <div class="upload-container upload-reverso">
                        <input type="file" (change)="onFileChangeReverso($event)" #imageInputReverso accept="image/*" />
                    </div>
                    <div class="detalle-archivo">
                        <p class="nombre-archivo">{{ nombreArchivoDniReverso }}</p>
                    </div>
                </div>
            </div>
            <div class="content-validacion-form-general">
                <span>{{ mensajeErrorDniObligatorio! }}</span>
            </div>
        </div>
        <!-- zona firma  -->
        <div id="formulario-firma" class="mt-1">
            <label class="detalle-titulo">
                {{'firma.titulo.detalle' | translate}}
                <span>*</span>
            </label>
            <div class="mb-0" id="input-firma-content" #inputFirmaContent>
                <canvas #idCanva id="canvas" [width]="withCanva" (mouseup)="mouseUp($event)"
                    (mouseout)="mouseUp($event)" (mousemove)="mouseMove($event)"
                    (mousedown)="mouseDown($event)"></canvas>
            </div>
            <div class="mt-0 text-end" id="clear-firma-content">
                <button class="firma-remoto"
                    (click)="solicitarFirma()">{{ 'firma-cliente-comun.solicitar-firma-email' | translate }}
                </button>
                <button (click)="limpiarFirma()">
                    <span class="align-middle material-symbols-outlined text-color-primary"> delete </span>
                    <span>{{'firma.rehacer-firma' | translate}}</span>
                </button>
            </div>
            <div class="checkbox-container">
                <div id="terminos-condiciones-content">
                    <input type="checkbox" class="custom-checkbox" id="acepto" name="acepto" [(ngModel)]="acepto">
                    <label for="acepto" class="txt-xsmall">{{'firma.acepto-recogida' | translate}} <a
                            class="primary-color"
                            (click)="abrirModalPoliticaPrivacidad()">{{'firma.acepto-recogida.enlace' |
                            translate}}</a></label>
                </div>
            </div>
            <div class="content-validacion-form-general text-center mb-1">
                <span>{{mensajeValidacionForm}}</span>
            </div>
            <div class="form-group text-end firma">
                <app-generic-field-button-next-back (click)="regresar()" class="boton-regresar btn" [direccion]="'back'"
                    [texto]="'Atrás'" [estilo]="'border'">
                </app-generic-field-button-next-back>
                <button class="btn-primary" (click)="procesarFirma()">{{'firma.campo.firma' | translate}}</button>
            </div>
        </div>
        <div id="form-group" id="content-footer-firma">
            <div class="text-center" id="titulo-footer-firma">{{'firma.duda' | translate}}</div>
            <div id="numero-footer-firma" class="text-color-primary text-center"> {{ agente.telefono }} </div>
            <div class="text-center" id="email-footer-firma">
                <a href="{{'mailto:' + agente.email}}" class="link-email-text">
                    {{'firma.duda.escribenos' | translate}}
                </a>
                <a href="{{'mailto:' + agente.email}}" class="align-middle" id="icono-mail"> <mat-icon>mail</mat-icon>
                </a>
            </div>

        </div>

        <div class="form-group text-center w-100" id="derechos-footer-firma">
            {{'texto-marca-registrada' | translate}}
        </div>

    </div>

</section>